/**
 * Shell del editor de pricing. La ruta /finance/pricing/:id cubre también
 * "new" (el editor trata id === "new" como versión nueva, paridad Replit).
 */
import PricingEditor from "@/components/finance/pricing/PricingEditor";

export default function PricingEditorPage() {
  return <PricingEditor />;
}
